export default "__VITE_ASSET__BVKMctSO__"